<template>
    <div
            ref="container"
            class="day-preview">

        <div class="date">
            <span class="day-of-month">
            {{ dayNumberInMonth }}
            </span>
        </div>

        <div class="jobs">
            <JobInDay
                    v-for="job in day.jobs"
                    v-bind:key="job.id"
                    v-bind:job="job"
                    v-bind:firstDisplayedHour="firstDisplayedHour"
                    v-bind:lastDisplayedHour="lastDisplayedHour"
            >
                {{ job.zip }}
            </JobInDay>

        </div>

        <div class="hours">
            <div
                    v-for="(hourData, hour) in day.hours"
                    v-if="hour >= firstDisplayedHour && hour <= lastDisplayedHour"
                    v-bind:class="[`${hourData.available ? 'available' : 'not-available'}-${hourData.availabilityType}`]"
                    class="hour">
                    <span class="hour_value" v-if="lastDisplayedHour===hour" @click="$emit('editDay', day)">

                    </span>
                    <span v-else>
                        <span v-if="hour > firstDisplayedHour">
                            {{ hour }}
                        </span>
                    </span>
                <div
                        v-if="hourData.zip !== null"
                        class="worker-present-in-zipcode-value">
                    {{ hourData.zip }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import JobInDay from './JobInDay';

    export default {
        components: {JobInDay},
        props: {
            user: Object,
            day: Object,
            firstDisplayedHour: Number,
            lastDisplayedHour: Number,
        },
        created() {
			this.day.jobs.forEach((job)=>{
				job.isToolTipOpen = "yeah";
            });
		},
		methods:{
            getLastHour(){
				return this.day.hours.slice(-1)[0]
			}
        },
        computed: {
            dayNumberInMonth() {
                return moment(this.day.date).format('DD');
            },
        },
    }
</script>

<style scoped lang="scss">
    .jobs {
        position: relative;
    }

    .day-preview {
        margin-bottom: 10px;
        cursor: pointer;
        //position: relative;
    }
    .date {
        position: relative;
        //top: 18px;
        left: 27px;
        font-size: 16px;
        font-weight: bold;
        color:white;
        z-index:333;
        //text-shadow: 0 0 5px #ffffff, 0 0 7px #ffffff, 0 0 18px #ffffff;
    }
    .date .day-of-month{
        position: absolute;
        top: 17px;
        left: -2.2%;
    }

    @media screen and (max-width: 600px) {
        .date .day-of-month{
            left: -19px;
            font-size: 14px;
        }
    }

    .hours {
        display: flex;
        flex-wrap: nowrap;
    }

    .worker-present-in-zipcode-value {
        color: #a7a7a7;
        width: 100%;
        white-space: nowrap;
        font-size: 10px;
        height: 24px;
        margin-top: 4px;
    }

    .not-available-weekly .hour_value{
        position: absolute;
        width: 100%;
        height: 50px;
        left:0;
    }
    .not-available-weekly .hour_value{

    }

    .hour {
        height: 60px;
        display: inline-block;
        flex-grow: 1;
        width: 50px;
        text-align: center;
        margin-right: 1px;
        padding-bottom: 5px;
        padding-top: 6px;
        font-weight: bold;
        &.not-available-weekly, &.not-available-null {
            background: #242424;
            color: rgba(255, 255, 255, 0.77);
            position: relative;
        }

        &.not-available-punctual {
            background: #595959;
            color: rgba(255, 255, 255, 0.77);
            font-size:12px;
        }
        &.available-weekly {
            background: #E6ECF1;
            color: rgba(2, 2, 2, 0.65);
        }
        &.available-punctual {
            background: #FCFCFC;
            color: rgba(2, 2, 2, 0.64);
        }
    }

    .hours > .hour:last-child > .hour_value:before{
        content: "\F044";
        visibility: visible;
        font: normal normal normal 14px/1 FontAwesome;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        contain:size;
        font-size:18px;
        font-weight: bold;
        line-height: 52px;
        padding-left:4px;
    }

    .hours > .hour:first-child,
    .hours > .hour:last-child
    {
        /*z-index:222;*/
        .hour_value{
            //visibility: ;
        }
    }
</style>
